const navItems = [
    {
        text: "Home",
        href: "#hero",
    },
    {
        text: "Sobre",
        href: "#sobre",
    },
    {
        text: "Apoio ao Estudante",
        href: "#apoio",
    },
    {
        text: "Contactos",
        href: "#contactos",
    },
    {
        text: "Tornar Sócio",
        href: "https://forms.cloud.microsoft/e/D0wc5CqmKn?origin=lprLink",
    },
    {
        text: "Regulamento",
        href: "./Regulamento Interno NEEQ-FEUP.pdf",
        download: true,
    }
];

export default navItems;
